export const Logo = ({ className = "", height = 34 }) => {
  return (
    <div
      className={`inline-flex items-center rounded-lg bg-transparent px-1 py-1 dark:bg-white dark:px-3 dark:py-1.5 dark:shadow-sm ${className}`}
      data-testid="brand-logo"
    >
      <img
        src="/logo-full.png"
        alt="Hampton Direct — Enriching Life Through Innovation"
        style={{ height }}
        className="w-auto object-contain"
      />
    </div>
  );
};

export const LogoMark = ({ className = "", height = 32 }) => {
  return (
    <img
      src="/logo-mark.png"
      alt="Hampton Direct"
      style={{ height }}
      className={`w-auto object-contain ${className}`}
      data-testid="brand-logo-mark"
    />
  );
};
